import popups from "@/libs/popups"
import escapeXml from "@/libs/escapeXml"
import store from "@/store/index"
import {config} from "@/libs/config"

/** Ошибка из шлюза запросов */
export class GatewayError extends Error {
    constructor(message, name=null, payload=null, logId=null) {
      super(message)
      this.name = name || "GatewayError"
      this.payload = payload
      this.logId = logId
    }
}

/** Детальная ошибка запроса */
export class QueryError extends Error {
    constructor(message, queryName, params, logId) {
        super(message)
        this.queryName = queryName || "unknown"
        this.params = params || {}
        this.logId = logId
    }
}

/** Ошибка пользователя - выводится на экран */
export class UserError extends Error {}
/** Ошибка сессии - надо переавторизоваться */
export class SessionError extends Error {}
/** Ошибка соединения - надо дождаться соединения */
export class ConnectionError extends Error {}

export let processError = function(err) {
    console.error(err.name+':', err);
    let isDebug = config.debug;

    //Просто строка
    if (isDebug && typeof(err)==='string') {
        return 'String:<br>'+err
    }
    
    if (err instanceof UserError) {
        return err.message
    
    } else if (err instanceof SessionError) {
        //Logout
        store.commit('session/clear')
        return null

    } else if (err instanceof QueryError) {
        return 'Query Error '+err.queryName+':<br>'+
            escapeXml(JSON.stringify(err.params||{},null,2))+'<br>'+
            escapeXml(err.message||'');

    //GatewayError
    } else if (err instanceof GatewayError) {
        return 'ServerError: '+err.message

    //Объект JS эксепшн
    } else if (typeof(err)==='object' && typeof(err.message)==='string') {
        let message = err.message
        if (message === "ResizeObserver loop limit exceeded") {
            return null
        }
        if (!isDebug) {
            return null
        }
        return message;
    }

    return 'Unknown Error';
};

export let showError = function(err) {
    let message = processError(err);
    if (!message) return;
    message = message.replace(/(?:\r\n|\r|\n)/g, '<br/>'); //nl2br
    popups.alert(message);
};
